import { DropdownMenuProps } from '@engyalo/delivery-ui-components/lib/ui/components/DropdownMenu'
import { DefaultProps } from '../../../interfaces'
import { TemplateActionNames } from '../defaultConstants'

export const NavMenuDefault: DefaultProps<DropdownMenuProps> = {
  options: '{{catalog.categoryList}}' as any,
  value: '{{catalog.currentCategory.slug}}',
  changeActions: {
    cinnamonActions: [
      {
        name: TemplateActionNames.CATALOG_SCROLL_TO_CATEGORY,
        args: {
          category: '{{this.newValue}}',
        },
      },
    ],
  } as any,
}
